import { NgModule } from '@angular/core';
import { BetonDataAccessModule } from '@beton/data-access';
import { BetonFeatureModule } from '@beton/feature';
import { SdvorBetonUiModule } from '@sdvor/beton/ui';

@NgModule({
  imports: [SdvorBetonUiModule, BetonDataAccessModule, BetonFeatureModule],
})
export class SdvorBetonShellModule {}
